var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('rkm-form',{ref:"RkmForm",attrs:{"show-legend":""}},[_c('rkm-row',[_c('rkm-col',[_c('rkm-form-input',{attrs:{"validations":_vm.validations.nome,"label":"Nome","uppercase":""},model:{value:(_vm.model.nome),callback:function ($$v) {_vm.$set(_vm.model, "nome", $$v)},expression:"model.nome"}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }